import React from 'react'
import { createRoot } from 'react-dom/client'
import { encodeForURL } from '../../../global/formatters/string-formatter.js'

import 'url-search-params-polyfill'

import { getAdvisorPathIfLocal } from '../../../global/environments/index.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import { sanitizeUrl } from '../../../global/formatters/sanitize-url.js'

import { SERVICE_LABEL_WHOLESALER } from './Helper/constants.js'

import {
  getSubscriptionsForUser,
  getStorageProfile,
} from '../Data/SubscriptionCenterDataSource.js'

import EmailSubscriptionCenterLanding from './EmailSubscriptionCenterLanding.jsx'

class EmailSubscriptionCenterLandingElement extends HTMLElement {
  redirectToSignIn(queryParam) {
    const _queryParam = encodeForURL(queryParam)
    const advisorPath = getAdvisorPathIfLocal()
    window.location.href = sanitizeUrl(
      advisorPath + '/subscribe/sign-in' + (_queryParam || '')
    )
  }

  async connectedCallback() {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('emailId')

      if (token && token.length > 10) {
        this.redirectToSignIn(window.location.search)

        return
      }
    }

    if (!isLoggedIntoSubscriptionCenter()) {
      this.redirectToSignIn()

      return
    }

    const subscriptionProfile = (await getSubscriptionsForUser()).value
    if (!subscriptionProfile) {
      this.redirectToSignIn()

      return
    }

    const storageProfile = getStorageProfile()

    if (storageProfile && storageProfile.role === SERVICE_LABEL_WHOLESALER) {
      subscriptionProfile.role = SERVICE_LABEL_WHOLESALER
    }

    const reactContainerId = 'email-subscription-center-landing-react-app'
    const reactContainerClass = 'u-bgColorLight'

    const productTypesDataString = document.getElementById('product-types-data')
    const productTypesData = JSON.parse(productTypesDataString.innerHTML)

    const assetClassesDataString = document.getElementById('asset-classes-data')
    const assetClassesData = JSON.parse(assetClassesDataString.innerHTML)

    const wholesalerLabelsDataString = document.getElementById(
      'wholesaler-labels-data'
    )
    const wholesalerLabelsData = JSON.parse(
      wholesalerLabelsDataString.innerHTML
    )

    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    reactContainer.setAttribute('class', reactContainerClass)
    this.appendChild(reactContainer)

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(
      <EmailSubscriptionCenterLanding
        userSubscriptionProfile={{ ...storageProfile, ...subscriptionProfile }}
        productTypes={productTypesData.productTypes}
        assetClasses={assetClassesData.assetClasses}
        wholesalerLabels={wholesalerLabelsData.wholesalerLabels}
      />
    )
  }
}

customElements.define(
  'email-subscription-center-landing',
  EmailSubscriptionCenterLandingElement
)
